import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
export const Filter = (param)=>{
    let { size = 24, testId, style, className } = param;
    return /*#__PURE__*/ _jsx("svg", {
        width: size,
        height: size,
        "data-testid": testId,
        style: style,
        className: className,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ _jsx("path", {
            d: "M4.12503 19.875C4.12503 21.3247 5.30028 22.5 6.75003 22.5C8.19978 22.5 9.37503 21.3247 9.37503 19.875M4.12503 19.875C4.12503 18.4253 5.30028 17.25 6.75003 17.25C8.19978 17.25 9.37503 18.4253 9.37503 19.875M4.12503 19.875H1.50003M9.37503 19.875H21.6251M4.125 4.125C4.125 5.57475 5.30025 6.75 6.75 6.75C8.19975 6.75 9.375 5.57475 9.375 4.125M4.125 4.125C4.125 2.67525 5.30025 1.5 6.75 1.5C8.19975 1.5 9.375 2.67525 9.375 4.125M4.125 4.125H1.5M9.375 4.125L21.625 4.125M19 12C19 13.4497 17.8248 14.625 16.375 14.625C14.9253 14.625 13.75 13.4497 13.75 12M19 12C19 10.5503 17.8248 9.375 16.375 9.375C14.9253 9.375 13.75 10.5503 13.75 12M19 12H21.625M13.75 12H1.5",
            stroke: "currentColor",
            strokeWidth: 1.5 * (24 / size),
            strokeLinecap: "round"
        })
    });
};
